<template>
  <form @submit.prevent="submitUserForm">
    <div class="row">
      <div class="col-lg-6 col-md-6 mb-3">
        <label class="mb-1">{{ $t('Full Name') }}</label><span class="text-danger">*</span>
        <input type="text" class="form-control" v-model="form.name" :placeholder="$t('Full Name')" />
        <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
      </div>

      <div class="col-lg-6 col-md-6 mb-3">
        <label class="mb-1">{{ $t('Email') }}</label>
        <input type="email" class="form-control" v-model="form.email" :placeholder="$t('Your Email')" />
        <small class="text-danger" v-if="errors.email">{{ errors.email[0] }}</small>
      </div>
    </div>

    <!-- <div class="row">
      

      <div class="col-lg-6 col-md-6 mb-3">
        <label class="mb-1">{{ $t('State') }}</label>
        <select class="form-control" v-model="form.state">
          <option value="" disabled>{{ $t('Select State') }}</option>
          <option v-for="state in props.states" :key="state.value" :value="state.value">{{ state.label }}</option>
        </select>
        <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
      </div>
    </div> -->


    <div class="row">


      <div class="col-lg-6 col-md-6">
        <div class="form-group mb-3">
          <label class="mb-1">{{ $t('Phone') }}</label>
          <span class="text-danger">*</span>
          <input
            ref="phoneInput"
            type="tel"
            class="form-control"
            name="phone"
            :placeholder="$t('Phone')"
          />
          <small
            class="text-danger"
            v-if="errors.phone"
          >
            {{ errors.phone[0] }}
          </small>
        </div>
      </div>


      <div class="col-lg-6 col-md-6 mb-3">
        <label class="mb-1">{{ $t('Password') }}</label><span class="text-danger">*</span>
        <input type="password" class="form-control" v-model="form.password" placeholder="*******" />
        <small class="text-danger" v-if="errors.password">{{ errors.password[0] }}</small>
      </div>

      <!-- <div class="col-lg-6 col-md-6 mb-3">
        <label class="mb-1">{{ $t('Category') }}</label>
        <select class="form-control" v-model="form.categories" multiple>
          <option value="" disabled>{{ $t('Select Category') }}</option>
          <option v-for="category in props.categories" :key="category.value" :value="category.value">
            {{ category.label }}
          </option>
        </select>
        <small class="text-danger" v-if="errors.categories">{{ errors.categories[0] }}</small>
      </div> -->
    </div>

    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary full-width fw-medium"
        :disabled="isSubmitting"
      >
        <span v-if="isSubmitting">
          {{ $t('Creating...') }}
        </span>

        <span v-else>
          {{ $t('Create An Account') }}
          <i
            class="fa-solid px-2"
            :class="$i18n.locale === 'ar'
              ? 'fa-arrow-left-long'
              : 'fa-arrow-right-long'"
          ></i>
        </span>
      </button>
    </div>
  </form>
</template>

<script setup>
// import { ref,defineProps} from 'vue'
import { ref ,onMounted, onBeforeUnmount} from 'vue'
import axios from 'axios'
import {useI18n} from "vue-i18n";
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
const toast = useToast();
const  {t} = useI18n();
const router = useRouter();
// const props = defineProps({
//   states: Array,
//   categories: Array
// });

const phoneInput = ref(null)
const phoneIti = ref(null)
const isSubmitting = ref(false)

const errors = ref({})
const form = ref({
  name: '',
  email: '',
  phone: '',
  password: '',
  // state: '',
  // categories: [],
})
const validatePhone = (itiInstance, inputRef, field, required = false) => {
  if (!itiInstance || !inputRef) {
    return true
  }

  const rawValue = inputRef.value?.trim()

  if (!rawValue && !required) {
    form.value[field] = ''
    return true
  }

  if (!rawValue && required) {
    errors.value[field] = [
      t('validation.required', {
        field: t(`fields.${field}`)
      })
    ]

    return false
  }

  if (!itiInstance.isValidNumber()) {
    errors.value[field] = [
      t('validation.invalid_phone')
    ]

    return false
  }

  form.value[field] = itiInstance.getNumber()

  return true
}
const submitUserForm = async () => {
  if (isSubmitting.value) return
  errors.value = {}
  let formValid = true;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const requiredFields = [ 'password'];
  requiredFields.forEach((field) => {
    if (!form.value[field] || (Array.isArray(form.value[field]) && form.value[field].length === 0)) {
      errors.value[field] = [
        t('validation.required', { field: t(`fields.${field}`) })
      ];
      formValid = false;
    }
  });

  const mainPhoneValid = validatePhone(
    phoneIti.value,
    phoneInput.value,
    'phone',
    true
  )

  if (!mainPhoneValid) {
    formValid = false
  }


  if (form.value.email && !emailRegex.test(form.value.email)) {
    errors.value.email = [t('validation.invalid_email')];
    formValid = false;
  }

  if (!formValid) return; 
  isSubmitting.value = true
  try {
    const formData = new FormData()

    Object.entries(form.value).forEach(([key, value]) => {
      formData.append(key, value ?? '')
    })

    const res = await axios.post('/users/normal-user/register', formData);
    console.log('User registered:', res.data);
    const userId = res.data.user_details.id
    const token = res.data.token
    const userRole = res.data.user_details.user_role;
    localStorage.setItem('auth_token', token) 
    localStorage.setItem('user_type', userRole);  
    localStorage.setItem('user_id', userId);  
    console.log('Login successful:',  res.data.user_details.id)
    

    // toast.success(t('You should wait for confirmation.'));
    form.value = {
      name: '',
      email: '',
      phone: '',
      password: '',
      // state: null,
      // categories: []
    };
    errors.value = {};
    if (userRole === 'Service Provider') {
      router.push(`/dashboard/${userId}`);
    } else {
      router.push(`/user_dashboard/${userId}`);
    }
  } catch (error) {
    if (error.response && error.response.status === 422) {
      errors.value = error.response.data || {};
      const msg = Object.values(errors.value).flat().join('\n');
      toast.error(msg);
    } else {
      toast.error(t('An unexpected error occurred. Please try again.'));
      console.error('Registration error:', error);
    }
  }finally {
    isSubmitting.value = false
  }
}


onMounted(() => {
  const options = {
    loadUtils: () => import('intl-tel-input/utils'),
  }

  phoneIti.value = intlTelInput(phoneInput.value, options)
})

onBeforeUnmount(() => {
  phoneIti.value?.destroy()
})

</script>
<style>
.iti {
  --iti-path-flags-1x: url('../../node_modules/intl-tel-input/build/img/flags.webp');
  --iti-path-flags-2x: url('../../node_modules/intl-tel-input/build/img/flags@2x.webp');
  --iti-path-globe-1x: url('../../node_modules/intl-tel-input/build/img/globe.webp');
  --iti-path-globe-2x: url('../../node_modules/intl-tel-input/build/img/globe@2x.webp');
}

.iti input.iti__tel-input, .iti input.iti__tel-input[type=text], .iti input.iti__tel-input[type=tel]
  {
    position: relative;
    z-index: 0;
    margin: 0 !important;
    width: 337px;
    text-align: start;
  }

  [dir="ltr"] .iti input.iti__tel-input {
  text-align: left;
  }

  [dir="rtl"] .iti input.iti__tel-input {
    text-align: right;
  }
</style>
